import { combineReducers } from '@reduxjs/toolkit';

import login from './auth/login/slices';
import refresh from './auth/refresh/slices';
import contracts from './contracts/slices';
import entitlements from './entitlements/slices';
import notifications from './notifications/slices';
import quotes from './quotes/slices';
import recovery from './recovery/slices';
import register from './register/slices';
import user from './user/slices';

const rootReducer = combineReducers({
  login,
  refresh,
  user,
  recovery,
  register,
  notifications,
  contracts,
  entitlements,
  quotes,
});

export type AppState = ReturnType<typeof rootReducer>;
export default rootReducer;
